import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Config, DateUtils, TrackingUtils } from '../../../utils';
import Field from './Field';
import { EntryPoint, FieldType } from '../../../models';
import { DatesRoundTripFragment } from '../MobileFragments';
import { ConnectedSegmentDateRoundTrip } from '../Segment/SegmentDateRoundTrip';
import { ErrorUtils } from '../../../utils/ErrorUtils';
import { getActiveProduct } from '../../../redux/currentSearch/selectors';

export const getFormattedDate = (dates, dateFormat, direction = 'rtl') => {
    const format = (date) => (date ? DateUtils.formatDate(date, dateFormat) : '');

    const [first, second] = dates;
    if (!first && !second) {
        return '';
    }

    if (direction === 'rtl') {
        return [second, first].map(format).join(' - ');
    }

    return [first, second].map(format).join(' - ');
};

export const DateFieldRoundTripInner = ({
    dates,
    error,
    ErrorMessageComponent,
}) => {
    const activeProduct = useSelector((state) => getActiveProduct(state));
    const { t } = useTranslation();
    const dateFormat = t('calendar.dateFormatOneLiner');
    const direction = Config.get('isRtl') ? 'rtl' : 'ltr';

    const placeholder = t('flightsManager.placeholder.date.roundTrip');
    const getErrorMessage = (error) => t(ErrorUtils.getDatesErrorKey(error), ErrorUtils.getDatesErrorKeyArgs(error));

    useEffect(() => {
        if (activeProduct === EntryPoint.HOTELS && error?.error === 'hotels_max_date' && dates?.length) {
            const [first, second] = dates;
            const diffDates = DateUtils.getDifferenceInDays(first, second);
            const label = TrackingUtils.LABEL.hotelsCalendarErrorMaxDays(diffDates);
            const action = TrackingUtils.ACTION[activeProduct.toUpperCase()];
            TrackingUtils.trackEvent({ action, label });
        }
    }, [activeProduct, dates, error]);


    return (
        <Field
            icon="calendar"
            id={FieldType.DATE}
            placeholder={placeholder}
            value={getFormattedDate(dates, dateFormat, direction)}
            errorMessage={getErrorMessage(error)}
            ErrorMessageComponent={ErrorMessageComponent}
        />
    );
};

DateFieldRoundTripInner.defaultProps = {
    error: null,
};

DateFieldRoundTripInner.propTypes = {
    dates: PropTypes.arrayOf(Date).isRequired,
    error: PropTypes.object,
    ErrorMessageComponent: PropTypes.func,
};

export const DateFieldRoundTrip = ({ ErrorMessageComponent }) => {
    return (
        <ConnectedSegmentDateRoundTrip>
            {({ error, dates }) => (
                <>
                    <DateFieldRoundTripInner dates={dates} error={error} ErrorMessageComponent={ErrorMessageComponent} />
                    <DatesRoundTripFragment />
                </>
            )}
        </ConnectedSegmentDateRoundTrip>
    );
};

DateFieldRoundTrip.propTypes = {
    ErrorMessageComponent: PropTypes.func,
};
